import axios from "axios";

export default axios.create({
  baseURL: window.location.hostname =='localhost'?process.env.REACT_APP_LOCAL_SERVER:window.location.hostname =='etrack.amsegroup.com.au'?process.env.REACT_APP_ETRACK_SERVER:process.env.REACT_APP_IP_SERVER,
  headers: {
    "Content-type": "application/json"
  }
  
});
